import Organizations from "entities/Organizations";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BiPlus } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import Card from "shared/components/Card";
import Header from "shared/components/Header";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { ORGANIZATION_TYPES, SCREENS } from "utils/constants";
import View from "./View";

const List = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.ORGANIZATION);
  const LIST = t("LIST", { returnObjects: true });

  const onDetail = (id) =>
    navigate(`${SCREENS.PRIVATE.ADMIN.ORGANIZATIONS.DETAIL.path}/${id}`);

  const onDelete = (id) =>
    navigate(`${SCREENS.PRIVATE.ADMIN.ORGANIZATIONS.DELETE.path}/${id}`);

  const [pagination, setPagination] = useState({});
  const [filter, setFilter] = useState({
    where: {
      type: ORGANIZATION_TYPES.INS,
    },
  });

  const onSearch = (target) => {
    setPagination((prev) => ({ ...prev, skip: 0 }));
    setFilter((prev) => ({
      ...prev,
      like: {
        ...prev.like,
        OR: [
          {
            name: `%${target.value}%`,
          },
        ],
      },
    }));
  };

  const addOrganization = () =>
    navigate(SCREENS.PRIVATE.ADMIN.ORGANIZATIONS.CREATE.path);

  return (
    <>
      <Header
        key={"header"}
        title={LIST.HEADER.TITLE}
        actions={[
          {
            icon: <BiPlus size={20} />,
            text: LIST.HEADER.CREATE,
            onClick: addOrganization,
          },
        ]}
      />
      <Card type={"simple"}>
        <div className="grid--4 m-bottom-24">
          <Input
            type="search"
            placeholder={LIST.SEARCH}
            onChange={({ target }) => onSearch(target)}
          />
        </div>

        <Organizations
          View={View}
          onDetail={onDetail}
          onDelete={onDelete}
          addOrganization={addOrganization}
          filter={{ ...filter, ...pagination }}
          setValues={setPagination}
          skip={pagination.skip || 0}
          NoData={View}
        />
      </Card>
    </>
  );
};

export default List;
